import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSimpleAuth } from '../lib/supabase';
import { AdminLayout } from '../layouts/AdminLayout';

export function ProtectedRoute() {
  const { isAdmin, user, loading } = useSimpleAuth();

  // Show loading while auth is initializing
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-warm-white to-light-gray dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
        <div className="flex items-center gap-3 text-gray-600 dark:text-gray-300">
          <div className="w-6 h-6 border-2 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated or not admin
  if (!user || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}